import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('track/list', { params });
  },
  async detaillist(params: any) {
    return axios.get('track/detaillist', { params });
  },
  async detail(params: any) {
    return axios.get('track/detail', { params });
  }
};
